<template>
  <div>
    <v-container class="pb-12 pt-3 Kanit" style="max-width: 500px; background-color: #FFF;">
      <h3 class="red--text mb-3" style="font-weight: 700">แจ้งปัญหาสินค้า</h3>
      <v-divider></v-divider>
      <div>
        <ValidationObserver ref="observer">
          <div>
            <div class="my-3">
              <span class="red--text" style="font-weight: 700">*</span> เลขที่ออเดอร์
            </div> 
            <ValidationProvider
              rules="required"
              name="เลขที่ออเดอร์"
              v-slot="{ errors }"
            >
              <v-text-field
                auto-grow
                outlined
                dense
                v-model="input.order_id"
                :error-messages="errors"
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div>
            <div class="mb-3">
              <span class="red--text" style="font-weight: 700">*</span> รายละเอียดสินค้าที่มีปัญหา
            </div> 
            <ValidationProvider
              rules="required"
              name="รายละเอียดสินค้าที่มีปัญหา"
              v-slot="{ errors }"
            >
              <v-textarea
                auto-grow
                outlined
                dense
                rows="3"
                v-model="input.desc"
                :error-messages="errors"
              ></v-textarea>
              <!-- <v-text-field
                outlined
                dense
                dark
                filled
                v-model="input.desc"
                :error-messages="errors"
              ></v-text-field> -->
            </ValidationProvider>
          </div>
          <div>
            <div class="mb-3">
              <span class="red--text" style="font-weight: 700">*</span> เบอร์โทรศัพท์
            </div> 
            <ValidationProvider
              :rules="{
                required: true,
                digits: 10,
                regex: /^[0][3-9][0-9]{4}[0-9]{4}$/,
              }"
              name="เบอร์โทรศัพท์"
              v-slot="{ errors }"
            >
              <v-text-field
                auto-grow
                outlined
                dense
                v-model="input.phone"
                :error-messages="errors"
                maxlength="10"
              ></v-text-field>
            </ValidationProvider>
          </div>
          <div class="pt-3">
            <div class="mb-2" style="font-weight: 700">ภาพสินค้า</div> 
            <ValidationProvider
              name="รูปที่ 1"
              v-slot="{ errors }"
            >
              <UploadDocument 
                v-model="input.img1" 
                :background="require(`@/assets/icon-upload.png`)"
                :isProfileImage="false"
              >
                <template v-slot="props">
                  <custom-input
                    :loading="props.loading"
                    :value="props.filename"
                    prepend-icon="mdi-attachment"
                    readonly
                    :error-messages="errors"
                  ></custom-input>
                </template>
              </UploadDocument>
            </ValidationProvider>
          </div>
          <div class="pt-3">
            <div class="mb-2" style="font-weight: 700">ภาพสินค้า</div> 
            <ValidationProvider
              name="รูปที่ 2"
              v-slot="{ errors }"
            >
              <UploadDocument 
                v-model="input.img2" 
                :background="require(`@/assets/icon-upload.png`)"
                :isProfileImage="false"
              >
                <template v-slot="props">
                  <custom-input
                    :loading="props.loading"
                    :value="props.filename"
                    prepend-icon="mdi-attachment"
                    readonly
                    :error-messages="errors"
                  ></custom-input>
                </template>
              </UploadDocument>
            </ValidationProvider>
          </div>
          <div class="pt-3">
            <div class="mb-2" style="font-weight: 700">ภาพสินค้า</div> 
            <ValidationProvider
              name="รูปที่ 3"
              v-slot="{ errors }"
            >
              <UploadDocument 
                v-model="input.img3" 
                :background="require(`@/assets/icon-upload.png`)"
                :isProfileImage="false"
              >
                <template v-slot="props">
                  <custom-input
                    :loading="props.loading"
                    :value="props.filename"
                    prepend-icon="mdi-attachment"
                    readonly
                    :error-messages="errors"
                  ></custom-input>
                </template>
              </UploadDocument>
            </ValidationProvider>
          </div>
        </ValidationObserver>
      </div>
      <v-divider></v-divider>
      <div class="text-right mt-3">
        <v-btn
          depressed
          color="#f5f5f5"
          @click="onCancel"
          class="mr-2"
        >
          Close
        </v-btn>
        <v-btn
          depressed
          dark
          color="#1867c0"
          @click="submitForm"
          :loading="saveloading"
        >
          Send
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
  import axios from "axios";
  import UploadDocument from "@/components/UploadSingleFile.vue";

  export default {
    data() {
      return {
        saveloading: false,
        input: {
          order_id: "",
          desc: "",
          phone: "",
          img1: "",
          img2: "",
          img3: ""
        },

      }
    },
    components: {
      UploadDocument
    },
    computed: {
      query() {
        return this.$store.state.query;
      }
    },
    methods: {
      async submitForm() {
        if (await this.$refs.observer.validate()) {
          var vm = this;
          let serverUrl = 'https://communitybotbyzwizai.herokuapp.com/tero/';
          let auth =  {
            "x-api-key": "7@cuTnLXX1TK78mHOJF#wI$NkkyG8A"
          }
          let img = {}
          const pageid = this.query.pageid;

          if(this.input.img1) {
            img.img_1 = this.input.img1;
          }
          if(this.input.img2) {
            img.img_2 = this.input.img2;
          }
          if(this.input.img3) {
            img.img_3 = this.input.img3;
          }

          var data = {
            title: vm.query.title ? vm.query.title : 'แจ้งปัญหาสินค้า' ,
            order_id: vm.input.order_id,
            desc: vm.input.desc,
            facebook_id: vm.$store.state.userid,
            phone: vm.input.phone,
            img:img
          };

          vm.saveloading = true;
          
          axios
            .post(`${serverUrl}reportproblem?pageid=${pageid}`, data, {
              headers: auth,
            })
            .then(async (response) => {
              vm.saveloading = false;
              if (response && response.data.responsecode == 200) {
                await vm.$swal.fire({ 
                  text: "แจ้งปัญหาเรียบร้อยแล้ว",  
                });

                if (vm.query.apptype == "line") {
                  vm.$liff.closeWindow();
                } else if (vm.query.apptype == "facebook") {
                  MessengerExtensions.requestCloseBrowser(
                    function success() {},
                    function error() {
                      window.close();
                    }
                  );
                }
              } else {
                await vm.$swal.fire({ 
                  text: response.data.reason 
                });

                if (vm.query.apptype == "line") {
                  vm.$liff.closeWindow();
                } else if (vm.query.apptype == "facebook") {
                  MessengerExtensions.requestCloseBrowser(
                    function success() {},
                    function error() {
                      window.close();
                    }
                  );
                }
              }
            });
        } 
      },
      onCancel() {
        var vm = this;
        if (vm.query.apptype == "line") {
          vm.$liff.closeWindow();
        } else if (vm.query.apptype == "facebook") {
          MessengerExtensions.requestCloseBrowser(
            function success() {},
            function error() {
              window.close();
            }
          );
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>